<template>



    
		<div
        v-if="$store.state.contactModal == true"
        id="contactModal"
        role="dialog"
        aria-modal="true"
        class="fade contanctModal centerModal smModal titleContainer modal show"
        tabindex="-1"
        aria-labelledby="contained-modal-title-vcenter"
        style="display: block; z-index: 1000000000"
    >
        <div
            class="modal-dialog modal-lg modal-dialog-centered"
        >
            <div class="modal-content">
                <button
                    @click="$store.state.contactModal = false"
                    type="button"
                    class="closeModalBtnContainer"
                >
                    <span class="closeModalBtn" aria-hidden="true"></span
                    ><span class="sr-only">Close</span>
                </button>
                <div class="modalHeader contanctContainer">
                    <h3 class="title">צור קשר</h3>
                    <p class="plainText">מלא את השדות ואנו נחזור אליכם בהקדם</p>
                </div>
                <div class="modalBody contanctContainer">
                    <form class="formContactUs">
                        <div class="inputContainer">
                            <input
                                name="name"
                                v-model="name"
                                class="genericInput"
                                type="text"
                                autocomplete="on"
                                maxlength="9999999"
                                placeholder="שם מלא"
                                value=""
                            /><button class="editBtn"></button>
                        </div>
                        <div class="inputContainer">
                            <input
                                v-model="emailAddress"
                                name="emailAddress"
                                class="genericInput"
                                type="email"
                                autocomplete="on"
                                maxlength="9999999"
                                placeholder="מייל"
                                value=""
                            /><button class="editBtn"></button>
                        </div>
                        <div class="inputContainer">
                            <input
                                v-model="subject"
                                name="subject"
                                class="genericInput"
                                type="text"
                                autocomplete="on"
                                maxlength="9999999"
                                placeholder="נושא הפנייה"
                                value=""
                            /><button class="editBtn"></button>
                        </div>
                        <div class="inputContainer">
                            <textarea
                                v-model="application"
                                name="application"
                                class="genericInput genericTextarea"
                                rows="6"
                                placeholder="תוכן הפנייה"
                            ></textarea>
                        </div>
                        <div>
                            <p class="plainText" style="color:red">{{ statusText }}</p>
                        </div>
                        <div class="formRecaptcha">
                            <form @submit.prevent="handleSubmit">
                                <div id="html_element"></div>
                                <br />
                                <button
                                    class="btn blue"
                                    type="submit"
                                    :disabled="!isRecaptchaValid"
                                >
                                    שליחה
                                </button>
                            </form>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>


</template>


<script>

export default {
    data() {
        return {
            showContactMsg: false,
            contactText: "",
            name: "",
            emailAddress: "",
            subject: "",
            application: "",
            recaptchaLoaded: false,
            recaptchaWidgetId: null,
            isRecaptchaValid: false,
            statusText: "",
        };
    },
    computed: {
        contactModal(){
            return this.$store.state.contactModal;
        }
    },
    
    methods: {
        submitContact(recaptcha) {
            var appVue = this;
            var name = this.name;
            var emailAddress = this.emailAddress;
            var subject = this.subject;
            var application = this.application;

            // Validate input and reCAPTCHA
            if (!name || !emailAddress || !subject || !application) {
                // set error msg
                appVue.statusText = "נא למלא את כל השדות";
                return;
            }

            // Send data to server
            fetch(appVue.$store.state.config.api_base + "/ContactUs", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name,
                    emailAddress,
                    subject,
                    application,
                    recaptcha,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    // error sample object
                    // {
                    // 	"success": false,
                    // 	"msgTitle": "נכשל השליחה",
                    // 	"msgContent": "השדה name חייב להכיל לפחות 2 תווים"
                    // }
                    //when response false: show error msg

                    if (data.success == false) {
                        appVue.statusText = data.msgTitle + ": " + data.msgContent;
                        return;
                    }

                    appVue.statusText = "הודעתך נשלחה בהצלחה!";
                    if (window.grecaptcha) {
                        var grecaptcha = window.grecaptcha;
                        grecaptcha.reset();
                    }

                    //close modal after 3 seconds
                    setTimeout(() => {
                        appVue.contactModal = false;
                        appVue.showContactMsg = true;
                        appVue.contactText = "הודעתך נשלחה בהצלחה!";
                    }, 1000);


                    //return;
                })
                // {
                // 	"success": false,
                // 	"msgTitle": "נכשל השליחה",
                // 	"msgContent": "השדה name חייב להכיל לפחות 2 תווים"
                // }
                // when response false: show error msg
                // when response true: show success msg
                                    //.then(() => {
                // // 	appVue.statusText = "הודעתך נשלחה בהצלחה!";
                // 	appVue.statusText = "הודעתך נשלחה בהצלחה!";
                // 	if (window.grecaptcha) {
                // 		var grecaptcha = window.grecaptcha;
                // 		grecaptcha.reset();
                // 	}

                // 	//close modal after 3 seconds
                // 	setTimeout(() => {
                // 		appVue.contactModal = false;
                // 		appVue.showContactMsg = true;
                // 		appVue.contactText = "הודעתך נשלחה בהצלחה!";
                // 	}, 1000);
                // })
                .catch((error) => {
                    console.error("Error:", error);
                    //alert('התרחשה שגיאה בשליחת ההודעה');
                    appVue.statusText = "התרחשה שגיאה בשליחת ההודעה";
                });
            },
    
        handleSubmit() {
            this.loadRecaptchaScript().then(() => {
                if (window.grecaptcha) {
                    var grecaptcha = window.grecaptcha;
                    const response = grecaptcha.getResponse(this.recaptchaWidgetId);
                    if (response.length === 0) {
                        alert("Please complete the reCAPTCHA");
                        return;
                    } else {
                        // Proceed with form submission
                        // alert("Form submitted successfully");
                        this.submitContact(response);
                    }
                }
            });
        },
        loadRecaptchaScript() {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src =
                    "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);

                window.onloadCallback = () => {
                    this.recaptchaLoaded = true;
                    resolve();
                };

                script.onerror = reject;
            });
        },
        renderRecaptcha() {
            if (this.recaptchaLoaded == true && window.grecaptcha) {
                var grecaptcha = window.grecaptcha;
                this.recaptchaWidgetId = grecaptcha.render("html_element", {
                    sitekey: "6LfoK-kpAAAAADtjZ-gf0LQGxCm9iGAvzOa52_3-",
                    callback: this.verifyCallback,
                    "expired-callback": this.expiredCallback,
                });
            }
        },
        verifyCallback(response) {
            if (response) {
                this.isRecaptchaValid = true;
            }
        },
        expiredCallback() {
            this.isRecaptchaValid = false;
        },
    },
    mounted() {
        this.loadRecaptchaScript().then(() => {
				this.renderRecaptcha();
			});
    },

};



</script>